import css from "./SecaoAvaliacoes.module.css"
import Avaliacao from "./Avaliacao";


function SecaoAvaliacoes() {
    return (
        <div className={`${css.geralAvaliacoes} mb-5`}>
            <Avaliacao txt1={"Serviço Incrível!"} txt2={"Excelente atendimento! A equipe da NeuroAudio é extremamente atenciosa, profissional e dedicada. Desde a primeira consulta, me senti acolhido e confiante no tratamento. Os resultados foram além das minhas expectativas. Recomendo muito!"} />
            <Avaliacao txt1={"Ótimo Atendimento"} txt2={"Clínica incrível! A NeuroAudio possui profissionais altamente qualificados e um ambiente muito acolhedor. O acompanhamento é personalizado e faz toda a diferença no progresso. Estou muito satisfeito com o atendimento e com a evolução obtida!"} />
            <div className={`${css.card2} d-flex flex-column justify-content-between align-items-center`}>
                <p className={css.audicao}>Sua Audição <br/> merece cuidado!</p>
                <img className={css.submarca} src="/Submarca%20Azul.jpg" alt=""/>
                <a className={`d-flex text-decoration-none justify-content-center ${css.btn}`} href={"/contatos"}><button className={`${css.contato} py-2 m-2`}>Entre em contato</button></a>
            </div>

        </div>
    );
}

export default SecaoAvaliacoes;
